import React, { useState } from 'react';
import { Button, Card, Form, Grid, Label, Message } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import { API, showError } from '../../helpers';

const initialForm = {
  upstream_code: '',
  message: '',
};

const TestPanel = () => {
  const { t } = useTranslation();
  const [form, setForm] = useState(initialForm);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const handleChange = (e, { name, value }) => {
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const res = await API.post('/api/admin/error-mapping-rules/test', form);
      const { success, message, data } = res.data;
      if (success) {
        setResult(data);
      } else {
        showError(message || t('error_mapping.messages.test_failed'));
      }
    } catch (error) {
      showError(error.message || t('error_mapping.messages.test_failed'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card fluid className='chart-card'>
      <Card.Content>
        <Card.Header className='header'>
          {t('error_mapping.test.title')}
        </Card.Header>
        <div style={{ color: '#777', fontSize: '12px', marginTop: '8px' }}>
          {t('error_mapping.test.description', {
            defaultValue: '粘贴一段上游错误信息，快速验证当前规则是否会命中。',
          })}
        </div>
        <Grid stackable columns={2} style={{ marginTop: '8px' }}>
          <Grid.Row>
            <Grid.Column>
              <Form>
                <Form.Input
                  label={t('error_mapping.test.upstream_code')}
                  name='upstream_code'
                  value={form.upstream_code}
                  onChange={handleChange}
                />
                <Form.TextArea
                  label={t('error_mapping.test.message')}
                  name='message'
                  value={form.message}
                  onChange={handleChange}
                  rows={3}
                />
                <Button primary loading={loading} onClick={handleSubmit}>
                  {t('error_mapping.test.submit')}
                </Button>
              </Form>
            </Grid.Column>
            <Grid.Column>
              <div
                style={{
                  background: '#fafafa',
                  border: '1px solid rgba(34,36,38,.08)',
                  borderRadius: '8px',
                  minHeight: '100%',
                  padding: '16px',
                }}
              >
                <div
                  style={{
                    color: '#888',
                    fontSize: '12px',
                    fontWeight: 600,
                    marginBottom: '10px',
                  }}
                >
                  {t('error_mapping.test.result_title', {
                    defaultValue: '测试结果',
                  })}
                </div>
                {result ? (
                  <Message positive={result.matched} warning={!result.matched}>
                    <Message.Header>
                      {result.matched
                        ? t('error_mapping.test.matched')
                        : t('error_mapping.test.unmatched')}
                    </Message.Header>
                    <div
                      style={{
                        marginTop: '8px',
                        display: 'flex',
                        gap: '8px',
                        flexWrap: 'wrap',
                      }}
                    >
                      <Label>{`${t('error_mapping.test.match_source')}: ${result.match_source}`}</Label>
                      <Label>{`${t('error_mapping.test.internal_code')}: ${result.internal_code || '-'}`}</Label>
                      <Label>{`${t('error_mapping.test.rule')}: ${result.matched_rule_name || '-'}`}</Label>
                    </div>
                    <div style={{ marginTop: '8px', lineHeight: 1.7 }}>
                      {`${t('error_mapping.test.display_message')}: ${result.display_message || '-'}`}
                    </div>
                  </Message>
                ) : (
                  <Message>
                    {t('error_mapping.test.result_empty', {
                      defaultValue: '填写左侧信息后点击"测试匹配"，结果会显示在这里。',
                    })}
                  </Message>
                )}
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Card.Content>
    </Card>
  );
};

export default TestPanel;
